export const isElectron = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf(" electron/") !== -1;
};
export const rowClassName = (withTotal = true) => (row, index) => {
  if (index === 0 && withTotal) return "font-bold bg-yellow-100";

  return "";
};
